<template>
  <b-container fluid class="mt-3">
    <!-- Main title -->
    <b-row align-v="center" class="justify-content-center mb-4">
      <div class="mb-2 main-title">
        <font-awesome-icon v-if="selectedGroup.name == 'Talento Humano'" :icon="['fas', 'users']"  fixed-width />
        <font-awesome-icon v-if="selectedGroup.name == 'Calidad'" :icon="['fas', 'file-check']"  fixed-width />
        <font-awesome-icon v-if="selectedGroup.name == 'Salud Ocupacional'" :icon="['fas', 'medkit']"  fixed-width />
        <span>{{ selectedGroup.name }}</span>
      </div>
    </b-row>
    <b-row>
      <b-col cols="12" lg="3" xl="2" style="margin-top: 14px;">
        <div class="d-lg-none mb-1 mr-3">
          <b-form-group>
            <template #label>
              <span style="color: #163D7D; font-weight: bold; font-size: 16px;">Seleccione una opción</span>
            </template>
            <b-form-select
              class="group-select"
              v-model="selectedGroup"
              :options="groupOptions"
            />
          </b-form-group>
        </div>

        <b-list-group class="d-none d-lg-flex"  v-for="group in groups" :key="group.id" >
          <b-list-group-item
            button
            :active="group.id == selectedGroup.id"
            :class="{'active-group': group.id == selectedGroup.id }"
            class="pl-2 group-item"
            @click="selectedGroup = group"
          >
            <p class="fs-title">{{group.name}}</p>
          </b-list-group-item>
        </b-list-group>
      </b-col>
      <b-col cols="12" lg="9" xl="10" class="pl-0">
        <component
          :is="selectedGroup.component"
          :links="currentGroupLinks"
          @openLink="openLink"
        >
          <b-row class="mt-3">
            <b-col cols="12">
              <b-container fluid class="px-0" >
                <b-form-group style="width: 100%">
                  <b-input-group>
                    <b-input
                      v-model="searchTerm"
                      placeholder="Buscar por nombre"
                    />
                    <b-input-group-append>
                      <b-button variant="outline-secondary" @click="searchTerm = ''">
                        <font-awesome-icon :icon="['far', 'undo-alt']" fixed-width />
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-container>
            </b-col>
          </b-row>
        </component>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import HumanResourcesSection from './HumanResourcesSection'
import CalidadSection from './CalidadSection'
import SaludOcupacionalSection from './SaludOcupacionalSection.vue'

import linksRrhh from '../../../sharedOptions/humanResourcesUrls.js';

export default {
  name: 'Index',
  components: {
    HumanResourcesSection,
    CalidadSection,
    SaludOcupacionalSection
  },
  data () {
    return {
      searchTerm: '',
      selectedGroup: { id: 1, name: 'Talento Humano', component: HumanResourcesSection },
      processing: false,
      groups: [
        { id: 1, name: 'Talento Humano', component: HumanResourcesSection },
        { id: 2, name: 'Calidad', component: CalidadSection },
        { id: 3, name: 'Salud Ocupacional', component: SaludOcupacionalSection }
      ],
      links: {
        1: linksRrhh,
        2: {
          1: [
            // {
            //   name: 'Registro de Queja',
            //   url: 'https://forms.office.com/pages/responsepage.aspx?id=QzZkyK-WgUeckMuikxzbomgJnzpHOJxEj9gYfcgyFVFUQjFCRVIyWFFFTTdKOExMOTFOUEVQRjc5RS4u&route=shorturl',
            //   type: 'url',
            //   description: 'Manifestación de insatisfacción de un Cliente sobre un producto, servicio o experiencia'
            // },
            // {
            //   name: 'Registro de PNC',
            //   url: 'https://forms.office.com/r/nVWhW6wHbu',
            //   type: 'url',
            //   description: 'Para órdenes finalizadas y entregadas, en las que se detectan errores post entrega, sin que haya mediado una queja del cliente'
            // },
            // {
            //   name: 'Registro de Incidente Operacional/Proceso',
            //   url: 'https://forms.office.com/pages/responsepage.aspx?id=QzZkyK-WgUeckMuikxzbomgJnzpHOJxEj9gYfcgyFVFURDlBM1ZIT0I0TlRLWDNCM0FUU0NORU5ZSi4u&route=shorturl',
            //   type: 'url',
            //   description: 'Evento no deseado o inesperado que interrumpe la actividad normal de la organización, causado por fallos en procesos internos, personal, sistemas o evento'
            // }
            {
              name: 'Eventos de Calidad',
              url: 'https://accesosautomaticos.sharepoint.com/sites/DepartamentoCalidad/_layouts/15/listform.aspx?PageType=8&ListId=%7B0BA4A6C7-826B-4F98-8D5D-50B2996461F4%7D&RootFolder=%2Fsites%2FDepartamentoCalidad%2FLists%2FRegistro%20de%20Eventos%20de%20Calidad&Source=https%3A%2F%2Faccesosautomaticos.sharepoint.com%2Fsites%2FDepartamentoCalidad%2FLists%2FRegistro%2520de%2520Eventos%2520de%2520Calidad%2FAllItems.aspx&ContentTypeId=0x0100E3AA0A45B1C6B140AA3FB652FE8DBD7000565DDC06A518584690089223FD11A46D',
              type: 'url',
              description: 'Registro de Queja, PNC o incidente Operacional'
            }
          ]
        },
        3: {
          1: [
            {
              name:'Alquiler de Equipo',
              url: 'https://www.ultradox.com/app/alquiterEquipoDO',
              type: 'url'
            },
            {
              name:'Entrega de EPP',
              url: 'https://accesosautomaticos.sharepoint.com/sites/DesarrolloOrganizacional/Lists/Entrega%20DO/AllItems.aspx',
              type: 'url'
            },
            {
              name:'Entrega de Zapatos',
              url: 'https://www.ultradox.com/app/18vvcNMYzAEq1QpJWDFuTcDqFtwqL3_2L',
              type: 'url'
            },
            {
              name:'Reporte de Accidentes',
              url: 'https://formularios.accesos.co.cr/accidentes',
              type: 'url'
            },
            {
              name:'Registro de Contratistas',
              url: 'https://www.ultradox.com/app/1kJF2MSTC7mOoK1O1VF3LOggaHsWYUayu',
              type: 'url'
            },
            {
              name:'Solicitud Compra de Zapatos',
              url: 'https://docs.google.com/forms/d/e/1FAIpQLSecRwqeCgXAewWJjmuEI7Ugl3D14XJ4Y3odiGGi8bujbbBCgQ/viewform?vc=0&c=0&w=1&pli=1',
              type: 'url'
            },
            {
              name:'5s Flotilla',
              url: 'https://accesosautomaticos.sharepoint.com/:l:/r/sites/DesarrolloOrganizacional/Lists/Formulario%205S?e=aIsfwd',
              type: 'url'
            },
            {
              name:'Reporte de Incidente',
              url: 'https://accesosautomaticos.sharepoint.com/sites/DesarrolloOrganizacional/Lists/Reporte%20de%20Incidente%20o%20Accidente%20en%20Propiedad%20del%20Cliente/AllItems.aspx',
              type: 'url'
            }
          ]
        }
      }
    }
  },
  computed: {
    groupOptions () {
      return this.groups.map(group => ({
        value: group,
        text: group.name
      }))
    },
    currentGroupLinks () {
      if (!this.selectedGroup) return []
      const links = this.links[this.selectedGroup.id]

      const searchTerm = this.searchTerm?.toLowerCase()
      if (searchTerm) {
        return this.filterByName(links, searchTerm)
      }
      // return this.sortByName(links)
      return links
    }
  },
  methods : {
    openLink (item) {
      if (!item || !item.url) return
      if (item.type == 'file') {
        this.downloadResource(item)
      } else {
        window.open(item.url);
      }
    },
    downloadResource(item) {
      if (this.processing) { return }
      this.processing = true
      this.$http.get('/api/production/documents/download_by_name', {
        params: {
          name: item.url
        }
      })
        .then((res) => {
          // console.log(res.data)
          window.open(res.data);
        })
        .catch(e => console.log(e))
        .finally(this.processing = false)
    },
    filterByName (items, searchTerm) {
      if (Array.isArray(items)) {
        const filteredItems = items.filter(link => {
          return link.name.toLowerCase().includes(searchTerm)
        })

        // return this.sortByName(filteredItems)
        return filteredItems
      }
      const results = {}
      Object.entries(items).forEach(([key, items]) => {
        const filteredItems = items.filter(item =>
          item.name.toLowerCase().includes(searchTerm)
        )
        // results[key] = this.sortByName(filteredItems)
        results[key] = filteredItems
      })

      return results
    },
    sortByName (links) {
      if (Array.isArray(links)) {
        return links.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
      }

      const results = {}
      Object.entries(links).forEach(([key, links]) => {
        const sortedItems = links.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
        results[key] = sortedItems
      })

      return results
    },
  }
}
</script>

<style lang="scss" scoped>
  .main-title {
    color: #163D7D;
    border-bottom: 2px solid #aaa;
    font-size: 1.7rem;
    align-items: center;
    font-weight: bolder;
  }

  .group-item {
    background: #43649a;
    border: none;
    border-radius: 5px;
    color: white;
    cursor: pointer;
    margin-top: 3px;
    margin-bottom: 6px;
    p {
      text-align: center;
      margin-bottom: 0;
    }
  }

  .group-select {
    border-color: #163D7D;
    color: #163D7D;
    font-weight: bold;
  }

  .active-group {
    background: #163D7D;
    box-shadow: 5px 5px rgba(88, 88, 88, 0.635);
  }

  .fs-title {
    font-weight: bold;
    font-size: 1rem;
  }
  // greater than Mac 14"
  @media (min-width: 1513px) {
    .fs-title {
      font-size: 1.2rem;
    }
  }

</style>
